class Storage {
  get<T>(key: string): T | null {
    if (typeof localStorage === 'undefined') return null;
    const data = localStorage.getItem(key);
    if (!data) return null;
    try {
      return JSON.parse(data) as T;
    } catch {
      return data as unknown as T;
    }
  }

  set<T>(key: string, value: T): void {
    if (typeof localStorage === 'undefined') return;
    const serialized = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, serialized);
  }

  remove(key: string): void {
    if (typeof localStorage === 'undefined') return;
    localStorage.removeItem(key);
  }

  clear(): void {
    if (typeof localStorage === 'undefined') return;
    localStorage.clear();
  }
}

export const storageService = new Storage();
